import { render, staticRenderFns } from "./headerAndModal.vue?vue&type=template&id=98e21076&scoped=true&"
import script from "./headerAndModal.vue?vue&type=script&defer=true&lang=js&"
export * from "./headerAndModal.vue?vue&type=script&defer=true&lang=js&"
import style0 from "./headerAndModal.vue?vue&type=style&index=0&id=98e21076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e21076",
  null
  
)

export default component.exports